module.exports = "/images/ar.svg";